import {mainQuery} from '@github-ui/react-core/future/main-query'
import {AssigneesResponseSchema} from '@github-ui/dotcom-schema/types/pull_requests/v1/assignees'
import {DevelopmentResponseSchema} from '@github-ui/dotcom-schema/types/pull_requests/v1/development'
import {LabelsResponseSchema} from '@github-ui/dotcom-schema/types/pull_requests/v1/labels'
import {pullRequestsAppBuilder} from '../config/app-builder'
import type {OverviewRoutePayload} from './route-payload-types'
import type {ReviewRequestsData} from '../page-data/payloads/review-requests'
import {pageDataQuery, pageDataQueryDeps} from './page-data-query'

export const pullRequestsOverviewRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsOverviewRoute', {
  path: '/:owner/:repo/pull/:pr_number/overview',
  queries: [
    mainQuery<OverviewRoutePayload>(),
    pageDataQuery<ReviewRequestsData, 'review_requests'>('review_requests', true),
    {
      queryName: 'assignees',
      queryDeps: ({params}) => pageDataQueryDeps({params, name: 'assignees'}),
      schema: AssigneesResponseSchema,
      persister: {
        enabled: true,
      },
    },
    {
      queryName: 'development',
      queryDeps: ({params}) => pageDataQueryDeps({params, name: 'development'}),
      schema: DevelopmentResponseSchema,
      persister: {
        enabled: true,
      },
    },
    {
      queryName: 'labels',
      queryDeps: ({params}) => pageDataQueryDeps({params, name: 'labels'}),
      schema: LabelsResponseSchema,
      persister: {
        enabled: true,
      },
    },
  ],
})
